import {
  REJECT_VALIDATION,REJECT_VALIDATION_LOADING,REJECT_VALIDATION_FAIL,
} from "./../actions/actionTypes";

const DEFAULT_STATE = {
  isDataLoaded:false,
  isLoading: false,
  timecard: {},
  error: {}
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case REJECT_VALIDATION_LOADING:
      return { ...state, isLoading: true };
    case REJECT_VALIDATION:
      return {
        ...state,
        isDataLoaded : true,
        isLoading: false,
        timecard: action.timecard
      };
    case REJECT_VALIDATION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    default:
      return state;
  }
};
